export default __webpack_public_path__ + "static/media/avatar.ba549fe5.png";